// Generated by ReScript, PLEASE EDIT WITH CARE


function options(container, renderer, path, loopOpt, autoplayOpt, param) {
  var loop = loopOpt !== undefined ? loopOpt : true;
  var autoplay = autoplayOpt !== undefined ? autoplayOpt : true;
  return {
          container: container,
          renderer: renderer,
          path: path,
          loop: loop,
          autoplay: autoplay
        };
}

export {
  options ,
}
/* No side effect */
